import React, { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as d3 from 'd3';
import { errorToast } from '../Common/showtoast';
import ApiRequest from '../Common/restservice';
let account = "";

var treemap01, svg01, i = 0,
    root01, duration01 = 750,
    selected01 = null,
    nodecount = 0,
    nodeChildrenData = {};
function SponsorTree() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    let { treeid } = useParams();
    useEffect(() => {
        if (!treeid) {
            treeid = localStorage.getItem("username");
        }
        GetDashboardDetails();
    }, [treeid])
    const GetDashboardDetails = async () => {
        let res = await ApiRequest("GetDashboardDetails.asp", "GET", null, { Authorization: localStorage.getItem("token") });
        if (res.status === "error") {
            errorToast(res.message);
            if (res.message === "Session Expired") {
                localStorage.clear();
                navigate("/login");
            }
            return;
        }
        console.log(res);
        account = {
            memberid: res.username,
            number_of_team: res.directcount,
            status:res.accountstatus
        }
        await processTree();
    }
    const refreshUI = async () => {
        let { status,number_of_team	 } = await viewUserReferrals(treeid);
        account = {
            memberid: treeid,
            number_of_team	: number_of_team	,
            status:status
        }
        console.log(account);
        await processTree();
        // await GetDashboardDetails();
    }
    const viewUserReferrals = async (memberid) => {
        var json = await ApiRequest("direct_sponsor_report.asp", "POST", {
            memberid: memberid
        }, {
            Authorization: localStorage.getItem("token")
        }, true);
        console.log(json);
        if (json.status !== "error") {
            return json;
        } else {
            return { items: [], status:"Inactive", number_of_team: 0 }
        }
    }

    const processTree = async (_elementId = "#tree", _userAddress = account) => {
        var array01 = [];
        var rootData01 = await getTreeData(_userAddress);
        var node01 = await renderTree01(_elementId, rootData01["treeData"]);
        if (rootData01.children) {
            for (var k = 0; k < rootData01.children.length; k++) {
                array01.push({
                    "address": rootData01.children[k],
                    "selected": node01
                });
            }
            for (var l = 0;
                (l < array01.length && l < 65536); l++) {
                var element01 = array01[l];
                var data01 = await getTreeData(element01["address"]);
                let node01 = await addChildren01(element01["selected"], data01["treeData"]);
            }
        }
    }
    const renderTree01 = async (elementId = "#tree", json_data = {}) => {
        var margin_top = 20,
            margin_right = 10,
            margin_bottom = 20,
            margin_left = 10,
            width = window.innerWidth*1.5 - margin_left - margin_right,
            height = window.innerHeight*1.5 - margin_top - margin_bottom;
        svg01 = d3.select(elementId).append("svg").attr("width", width + margin_right + margin_left).attr("height", height + margin_top + margin_bottom)
        .attr("viewBox", `0 0 ${width * 1.5} ${height * 1.5}`).call(d3.zoom().on("zoom", (function (event, d) {
            svg01.attr("transform", event.transform)
        }))).append("g").attr("transform", "translate(" + margin_left + "," + margin_top + ")");
        treemap01 = d3.tree().size([height, width]);
        root01 = d3.hierarchy(json_data, (function (d) {
            return d.children
        }));
        root01.x0 = height / 2;
        root01.y0 = 0;
        var node = await update01(root01);
        return node
    }
    const toggle = (d) => {
        if (d.children) {
            d._children = d.children;
            d.children = null;
        } else {
            d.children = d._children;
            d._children = null
        }
    }
    const update01 = async (source) => {
        var treeData = treemap01(root01),
            nodes = treeData.descendants(),
            links = treeData.descendants().slice(1);
        nodes.forEach((function (d) {
            d.y = 150 * d.depth + 50;
            d.x = d.x * 1.1;
        }));
        var link = svg01.selectAll("path.link").data(links, (function (d) {
            return d.id
        })),
            linkEnter, linkUpdate;
        link.enter().insert("path", "g").attr("class", "link").attr("d", (function (d) {
            var o = {
                x: source.x0,
                y: source.y0
            };
            return diagonal(o, o)
        })).merge(link).transition().duration(duration01).attr("d", (function (d) {
            return diagonal(d, d.parent)
        }));
        var linkExit = link.exit().transition().duration(duration01).attr("d", (function (d) {
            var o = {
                x: source.x,
                y: source.y
            };
            return diagonal(o, o)
        })).remove();

        function diagonal(s, d) {
            return `M ${s.y} ${s.x + 12}\n            C ${(s.y + d.y) / 2} ${s.x + 12},\n              ${(s.y + d.y) / 2} ${d.x + 12},\n              ${d.y} ${d.x + 12}`
        }
        nodes.forEach((function (d) {
            d.x0 = d.x;
            d.y0 = d.y;
        }));
        var node = svg01.selectAll("g.node").data(nodes, (function (d) {
            return d.id || (d.id = ++i)
        }));
        var nodeEnter = node.enter().append("g").attr("class", "node").style("cursor", function (d) {
            return "pointer"
        }).attr("transform", (function (d) {
            return "translate(" + source.y0 + "," + source.x0 + ")"
        })).on("click", click);

        // nodeEnter.append("circle")
        //     .attr("cx", 100)
        //     .attr("cy", 100)
        //     .attr("r", 80)
        //     .attr("fill", "#FFD700")
        //     .attr("stroke", "#000")
        //     .attr("stroke-width", "2");
        nodeEnter.append("path")
            .attr("d", function (d) {
                // Define the path commands for a rounded rectangle
                var x = -30; // X-coordinate of the top-left corner
                var y = 0; // Y-coordinate of the top-left corner
                var width = 100; // Width of the rectangle
                var height = 30; // Height of the rectangle
                var radius = 10; // Border radius
                return `M ${x},${y + radius}
                A ${radius},${radius} 0 0 1 ${x + radius},${y}
                L ${x + width - radius},${y}
                A ${radius},${radius} 0 0 1 ${x + width},${y + radius}
                L ${x + width},${y + height - radius}
                A ${radius},${radius} 0 0 1 ${x + width - radius},${y + height}
                L ${x + radius},${y + height}
                A ${radius},${radius} 0 0 1 ${x},${y + height - radius}
                L ${x},${y + radius} Z`;
            })
            .attr("fill", "lightgray");

        nodeEnter.append("text")
            .attr("x", 20)
            .attr("y", 20)
            .attr("text-anchor", "middle")
            .attr("alignment-baseline", "central")
            .style("fill", (function (d) {
                return d.data.active === "Active" ? "Green" : "Red"
            }))
            .style("font-weight", "bold")
            .text(function (d) {
                return "ID :" + d.data.memberid; // Assuming number_of_team is a property of your data
            });
        nodeEnter.append("a").attr("xlink:href", (function (d) {
            return d.url
        })).append("svg:text").attr("x", (function (d) {
            return d.children || d._children
        })).attr("dy", -5).attr("dx", "15px").style("z-index", "99").attr("text-anchor", (function (d) {
            return d.children || d._children ? "end" : "start"
        })).html((function (d) {
            return parseInt(d.data.number_of_team)
        })).style("fill", (function (d) {
            return "red"
        })).style("font-weight", (function (d) {
            return "bold"
        })).style("text-align", (function (d) {
            return "center"
        }));
        nodeEnter.append("svg:title").text(function (d) {
            return "ID : " + d.data.memberid + "\nDirect : " + d.data.number_of_team + "\n"
        });
        var nodeUpdate = nodeEnter.merge(node),
            nodeExit;
        async function click(event, d) {
            if (!d.working) {
                d.working = !0;
                var _childrenLength = d._children ? d._children.length : 0, childrenLength = d.children ? d.children.length : 0;
                if (!d.children && !d._children || 0 === _childrenLength && 0 === childrenLength || _childrenLength > 2 || childrenLength > 2)
                    if (nodeChildrenData[d.data.memberid] && 2 === nodeChildrenData[d.data.memberid].length) {
                        d._children = new Array;
                        d.data.children = new Array;
                        for (var i = 0; i < nodeChildrenData[d.data.memberid].length; i++) {
                            var data = nodeChildrenData[d.data.memberid][i];
                            var json_data = data.treeData, newNode;
                            newNode = d3.hierarchy(json_data);
                            newNode.depth = d.depth + 1;
                            newNode.height = d.height - 1;
                            newNode.parent = d;
                            newNode.id = Date.now();
                            d._children.push(newNode);
                            d.data.children.push(newNode.data);
                        }
                    } else {
                        d._children = new Array;
                        d.data.children = new Array;
                        var { items: children } = await viewUserReferrals(d.data.memberid);
                        if (0 === children.length) return;
                        if (children.length > 0) {
                            for (var i = 0; i < children.length; i++) {
                                var data = await getTreeData(children[i]);
                                var json_data = data.treeData, newNode;
                                newNode = d3.hierarchy(json_data);
                                newNode.depth = d.depth + 1;
                                newNode.height = d.height - 1;
                                newNode.parent = d;
                                newNode.id = Date.now();
                                d._children.push(newNode);
                                d.data.children.push(newNode.data)
                            }
                        }
                    }
                toggle(d)
                update01(d);
                d.working = false;
            }
        }
        return nodeUpdate.transition().duration(duration01).attr("transform", (function (d) {
            return "translate(" + d.y + "," + d.x + ")"
        })), nodeUpdate.select("circle.node").attr("r", 10).style("fill", (function (d) {
            return "#0e4677"
        })).attr("cursor", "pointer"), node.exit().transition().duration(duration01).attr("transform", (function (d) {
            return "translate(" + source.y + "," + source.x + ")"
        })).remove().select("circle").attr("r", 0), nodes.forEach((function (d) {
            d.x0 = d.x;
            d.y0 = d.y;
            selected01 = d
        })), selected01
    }
    const getTreeData = async (_userAddress = account) => {
        console.log(_userAddress);
        return {
            "treeData": {
                "memberid": _userAddress.memberid,
                "number_of_team": _userAddress.number_of_team,
                "active": _userAddress.status,
                "children": []
            }
        }
    }
    const addChildren01 = async (selected01, json_data = {}) => {
        var newNode = d3.hierarchy(json_data);
        newNode.depth = selected01.depth + 1;
        newNode.height = selected01.height - 1;
        newNode.parent = selected01;
        newNode.id = Date.now();
        if (!selected01.children)
            selected01.children = []
        if (!selected01.data.children)
            selected01.data.children = [];
        selected01.children.push(newNode);
        selected01.data.children.push(newNode.data);
        var node = await update01(selected01);
        return nodecount += 1, node
    }
    return (
        <section className="content">
            <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12 col-xm-12">
                    <div className="card overflow-hidden dash1-card border-0 ">
                        <div className="card-body">
                            <div id="tree" style={{ overflow: "auto !important" }}></div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SponsorTree
